function buildDownloadName(
  modelName: string | undefined,
  mode: string | undefined,
  url: string
): string {
  const ext = url.split('?')[0].split('.').pop() || 'jpg';
  const base = modelName ? modelName.replace(/\.[^.]+$/, '') : 'image';
  const suffix = mode ? ` ${mode}` : '';
  return `${base}${suffix}.${ext}`;
}

export default buildDownloadName;
